import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/80_card_back_halloween_pumpkin/80_card_back_halloween_pumpkin"
 * Contains 1 texture(s)
 */
export class CardsBacks80CardBackHalloweenPumpkinAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/80_card_back_halloween_pumpkin/80_card_back_halloween_pumpkin';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '80_halloween_pumpkin.png'
    ] as const;
}
